module.exports = function getResource(label, vars = []) {
    const resources = {
        beautyTraits: 'Atouts beauté',
        beautyTraitsInclude: 'Les traits de beauté sur votre profil comprennent:',
        beautyPreferences: 'Préférences beauté',
        beautyPreferencesInclude: 'Les préférences beauté sur votre profil comprennent:',
        skinType: 'Type de peau',
        skinTone: 'Teint',
        hairType: 'Type de cheveux',
        hairColor: 'Colorant capillaire',
        eyeColor: 'Couleur des yeux',
        colorIQ: 'Color IQ',
        beautyTraitsVisible: 'Qui peut voir les atouts beauté sur votre profil:',
        beautyPreferencesVisible: 'Les préférences beauté de votre profil sont visibles par:',
        everyone: 'Tout le monde',
        justMe: 'Juste moi',
        profile: 'Profil',
        yourProfileVisible: `Votre profil est visible pour: ${vars[0] ? 'Juste moi' : 'Tout le monde'}`,
        yourSkincareConcerns: 'Vos problèmes de peau et de cheveux sont toujours cachés dans votre profil de la collectivité. Les correspondances beauté qui ont vos même problèmes verront vos traits lorsque vous publiez une évaluation.',
        yourSkincareConcernsUpdated: 'Vos problèmes de peau et de cheveux n’apparaissent pas sur votre profil public.',
        yourBeautyInsider: 'Vos pages Listes et Comptes sont toujours privées.',
        yourBeautyInsiderUpdated: 'Vos pages Beauty Insider, Listes et Compte sont toujours privées.',
        forMoreInformation: 'Pour plus d’informations, consulter notre',
        termsOfUse: 'Conditions d’utilisation'
    };
    return resources[label];
};
